<template>
  <div class="footer">
    <div class="footer-con flex-row">
      <div class="footer-left">
        <img class="logo" :src="webInfo.logo" />
        <div class="company-info flex-col">
          <span>地址：{{ webInfo.address }}</span>
          <span>电话：{{ webInfo.phone }}</span>
          <span>邮箱：{{ webInfo.email }}</span>
          <span>传真：{{ webInfo.fax }}</span>
          <span>售后服务热线：{{ webInfo.servicePhone }}</span>
        </div>
      </div>
      <div class="grey-white"></div>
      <div class="footer-right justify-start" v-if="isPc">
        <div class="menu-item">
          <h3 @click="toPages('about')">关于冠龙</h3>
          <div class="menu-item-list flex-col">
            <span @click="toAbout('brief')">企业简介</span>
            <span @click="toAbout('culture')">企业文化</span>
            <span @click="toAbout('develop')">发展历程</span>
            <span @click="toAbout('qualification')">公司资质</span>
            <span @click="toAbout('detectability')">检测能力</span>
            <span @click="toAbout('project')">工程案例</span>
            <span @click="toAbout('info')">信息公开</span>
          </div>
        </div>
        <div class="menu-item menu-item2">
          <h3 @click="toPages('products')">产品系列</h3>
          <el-row class="menu-item-list">
            <el-col
              :span="12"
              v-for="item in typeListRes"
              :key="item.prodTypeId"
            >
              <span @click="toPages('products')">{{ item.prodTypeName }}</span>
            </el-col>
          </el-row>
        </div>
        <div class="menu-item">
          <h3 @click="toPages('news')">新闻中心</h3>
        </div>
        <div class="menu-item">
          <h3 @click="toPages('contact')">联系我们</h3>
          <div class="menu-item-list flex-col">
            <span @click="toPages('contact')">联系方式</span>
            <span @click="toPages('contact')">加入我们</span>
          </div>
        </div>
        <div class="menu-item">
          <h3 @click="toWebLink">投资者关系</h3>
        </div>
      </div>
      <div class="qcode">
        <img :src="webInfo.wxCodeImage" />
        <p>微信公众号</p>
      </div>
    </div>
    <div class="bottom justify-between items-end">
      <div>
        {{ webInfo.copyrightInfo }}
        <div style="margin-top: 4px" v-html="webInfo.recordNumber"></div>
      </div>
      <div>技术支持：台商汇信息科技（深圳）有限公司</div>
    </div>
    <div class="fix_btn">
      <el-popover
        placement="left"
        width="100"
        trigger="hover"
        popper-class="wx_popper"
      >
        <img :src="webInfo.wxCodeImage" style="width: 100px; height: 100px" />
        <div class="btn_wx" slot="reference">
          <img src="../../assets/images/wx.png" />
        </div>
      </el-popover>

      <el-popover
        placement="left"
        width="120"
        trigger="hover"
        popper-class="wx_popper"
      >
        <div>{{ webInfo.phone }}</div>
        <div class="btn_tel" slot="reference"><em></em></div>
      </el-popover>
      <el-popover
        placement="left"
        width="120"
        trigger="hover"
        popper-class="wx_popper"
      >
        <div class="little_hand" @click="dialogVisible = true">咨询留言</div>
        <div class="btn_join" slot="reference"><em></em></div>
      </el-popover>
      <!-- <div class="btn_top" @click="backTop"><em></em></div> -->
    </div>
    <el-dialog
      title="欢迎访问冠龙节能，请输入您需要咨询的内容"
      :visible.sync="dialogVisible"
      :width="isPc ? '70%' : '100%'"
      :before-close="handleClose"
    >
      <div class="bottom-pop">
        <el-form ref="form" :model="form" label-width="120px">
          <el-form-item
            label="所在省/市："
            prop="area"
            :rules="[{ required: true, message: '所在省/市不能为空' }]"
          >
            <cascader
              @provincesValueChang="provincesValueChang"
              :value="area"
              @update:value="area = $event"
              style="width: 100%"
            />
          </el-form-item>
          <el-form-item
            label="公司名称："
            prop="company"
            :rules="[{ required: true, message: '公司名称不能为空' }]"
          >
            <el-input v-model="form.company"></el-input>
          </el-form-item>
          <el-form-item
            label="联络方式："
            prop="phone"
            :rules="[{ required: true, message: '联络方式不能为空' }]"
          >
            <el-input v-model="form.phone"></el-input>
          </el-form-item>
          <el-form-item
            label="咨询内容："
            prop="consult"
            :rules="[{ required: true, message: '咨询内容不能为空' }]"
          >
            <el-input type="textarea" v-model="form.consult"></el-input>
          </el-form-item>
          
          <el-form-item label="备注：" prop="remark">
            <el-input type="textarea" v-model="form.remark"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">立即提交</el-button>
            <el-button @click="resetForm">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getTypeList } from "@/assets/api/products.js";
import { getWebInfo, getConsultSubmit } from "@/assets/api/about.js";
import cascader from "./cascader.vue";
export default {
  components: {
    cascader,
  },
  data() {
    return {
      typeListRes: [],
      webInfo: {},
      dialogVisible: false,
      form: {
        company: "",
        phone: "",
        consult: "",
        remark: "",
        area: "",
      },
        area: "",
    };
  },
  computed: {
    ...mapState(["isPc"]),
  },
  created() {
    getTypeList({
      orderByColumn: "orderNum",
      isAsc: "desc",
      pageNum: 1,
      pageSize: 100,
    }).then((res) => {
      // console.log(res.data);
      this.typeListRes = res.data.data.rows;
      // this.activeType = this.typeListRes[0].prodTypeId;
    });
    getWebInfo().then((res) => {
      this.webInfo = res.data.data;
      this.webInfo.wxCodeImage = this.$imgUrl + this.webInfo.wxCodeImage;
      this.webInfo.logo = this.$imgUrl + this.webInfo.logo;
    });
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
    },
    provincesValueChang(value) {
      this.area = value;
      this.form.area=value.toString().replace(/,/g,"/")
      console.log(this.form)
    },

    onSubmit() {
      console.log("submit!");
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              getConsultSubmit(this.form).then((res) => {
                console.log(res);
                if (res.data.msg == "操作成功") {
                  this.$message({
                    type: "success",
                    message: "提交成功!",
                  });
                  this.resetForm();
                  this.dialogVisible = false;
                }
              });
            })
            .catch(() => {});
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm() {
      this.area=''
      this.$refs.form.resetFields();
    },
    toPages(pageName) {
      this.$router.push({
        path: `/${pageName}`,
      });
    },
    toWebLink() {
      window.open("https://ir.p5w.net/c/301151.shtml", "_blank");
    },
    toAbout(type) {
      this.$router.push({
        path: `/about?type=${type}`,
      });
    },
    applyForAdmission() {},
    submit() {},
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.footer {
  background: #f8f8fa;
  .footer-con {
    position: relative;
    .qcode {
      position: absolute;
      right: 80px;
      top: 140px;
      font-family: MicrosoftYaHei;
      font-size: 14px;
      color: #2c2c2e;
      letter-spacing: 0;
      text-align: center;
      font-weight: 400;
      img {
        width: 140px;
        height: 140px;
        object-fit: contain;
        margin-bottom: 8px;
      }
    }
  }
  .footer-left {
    background: rgba($color: #000000, $alpha: 0.04);
    padding: 78px 80px 66px;
    .logo {
      width: 300px;
      height: 50px;
      object-fit: contain;
      margin-bottom: 24px;
    }
    .company-info {
      font-family: MicrosoftYaHei;
      font-size: 16px;
      color: #2c2c2e;
      letter-spacing: 0;
      font-weight: 400;
      span {
        margin-bottom: 12px;
      }
    }
  }
  .grey-white {
    width: 55px;
    height: 100%;
    border-top: 374px solid rgba($color: #000000, $alpha: 0.04);
    border-right: 55px solid #f8f8fa;
  }
  .footer-right {
    padding: 73px 80px;
    .menu-item {
      margin-right: 24px;
      flex: 1;
      h3 {
        font-family: MicrosoftYaHei-Bold;
        font-size: 18px;
        color: #2c2c2e;
        letter-spacing: 0;
        font-weight: 700;
        margin-bottom: 16px;
        cursor: pointer;
      }
      .menu-item-list {
        span {
          cursor: pointer;
          opacity: 0.8;
          font-family: MicrosoftYaHei;
          font-size: 16px;
          color: rgba($color: #2c2c2e, $alpha: 0.8);
          letter-spacing: 0;
          font-weight: 400;
          margin-bottom: 12px;
          display: block;
        }
      }
    }
    .menu-item2 {
      margin-right: 4px;
      flex: 2.5;
      .menu-item-list {
        margin-right: 20px;
      }
    }
  }
  .bottom {
    font-family: MicrosoftYaHei;
    font-size: 14px;
    color: rgba($color: #000000, $alpha: 0.32);
    letter-spacing: 0;
    font-weight: 400;
    padding: 20px 80px;
    background: #fff;
  }
  .fix_btn {
    position: fixed;
    top: 50%;
    right: 27px;
    z-index: 99;

    div {
      cursor: pointer;
      width: 48px;
      height: 48px;
      box-shadow: 0px 2px 7px 0px rgba(213, 213, 213, 0.75);
      border-radius: 60px;
      margin-bottom: 16px;
      background-color: #fff;
      background-size: contain;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    div:hover {
      background: rgba(0, 0, 0, 0.04);
    }
    em {
      width: 22px;
      height: 22px;
      display: inline-block;
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
    }
    .btn_wx img {
      width: 22px;
      height: 22px;
      object-fit: contain;
    }
    .btn_tel em {
      background-image: url("../../assets/images/tel.png");
    }
    .btn_top em {
      background-image: url("../../assets/images/top.png");
    }
    .btn_join em {
      background-image: url("../../assets/images/contact-msg.png");
    }
  }
}
@media screen and (max-width: 768px) {
  .footer {
    .footer-con {
      .qcode {
        position: absolute;
        right: auto;
        left: 40px;
        top: auto;
        bottom: 40px;
        font-family: MicrosoftYaHei;
        font-size: 14px;
        color: #2c2c2e;
        letter-spacing: 0;
        text-align: center;
        font-weight: 400;
        img {
          width: 140px;
          height: 140px;
          object-fit: contain;
          margin-bottom: 8px;
        }
      }
    }
    .footer-left {
      background: rgba($color: #000000, $alpha: 0.04);
      padding: 40px 0 230px 40px;
      .logo {
        width: 300px;
        height: 50px;
        object-fit: contain;
        margin-bottom: 24px;
      }
      .company-info {
        font-family: MicrosoftYaHei;
        font-size: 14px;
        color: #2c2c2e;
        letter-spacing: 0;
        font-weight: 400;
      }
    }
    .grey-white {
      width: 55px;
      height: 100%;
      border-top: 509px solid rgba($color: #000000, $alpha: 0.04);
      border-right: 50px solid #f8f8fa;
    }
    .bottom {
      flex-direction: column;
      font-size: 12px;
      font-weight: 400;
      padding: 10px 20px;
      align-items: baseline;
      div:first-child {
        margin-bottom: 4px;
      }
    }
  }
}
</style>
<style>
.el-popover {
  box-sizing: content-box;
}
.footer .el-dialog__title {
  font-size: 24px;
  font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
  font-weight: bold;
  color: #2c2c2e;
  line-height: 36px;
}
.footer .el-dialog__headerbtn {
  font-size: 28px;
}
.el-dialog__headerbtn:hover .el-dialog__close {
  color: #005bac;
}
.el-input__inner:focus,
.el-textarea__inner:focus {
  border-color: #005bac;
}
.el-button--primary {
  background-color: #005bac;
  border-color: #005bac;
}
.el-button--default:hover {
  color: #005bac;
  border-color: #005bac;
}
.el-form-item__label {
  font-size: 16px;
}

.footer .el-dialog__header {
  padding-right: 40px;
}
.footer .el-dialog__body {
  padding-right: 20px;
}
.el-cascader .el-input .el-input__inner:focus, .el-cascader .el-input.is-focus .el-input__inner{
  color: #005bac;
  border-color: #005bac;
}
.el-cascader-node.in-active-path, .el-cascader-node.is-active, .el-cascader-node.is-selectable.in-checked-path{
  color: #005bac;

}
</style>


// WEBPACK FOOTER //
// src/views/common/footer.vue